import { Attribute, Address, Billing_Data, Category, Currency, Item, Item_Exception, Offer, Order, Order_Item, Post, Price, Price_Type, Quote, Serial, Stock_Record, Stocktake, Stocktake_Item, Store, User, User_Attachment, User_Permission, Form, Question, Response, Answer, Requisition, Bank_Movement, FacturaMetaData, Preferences, Ecommerce, Item_Points, Ticket, Printer, Shipping_Item_Batch } from "../models/RestModels";
import { ItemInfo, ItemOptionInfo, OrderInfo, OrderItemInfo, QuoteInfo, SerialInfo, UserBalance, StocktakeItemInfo, StocktakeInfo, AnswerInfo, ResponseInfo } from "../models/models";
import { RestService } from "../services/rest.service";
import * as Empties from './Empties/index';

export class GetEmpty
{
	static attribute(): Attribute { return Empties.getEmptyAttribute(); }
	static ecommerce(): Ecommerce { return Empties.getEmptyEcommerce(); }
	static requisition(): Requisition { return Empties.getEmptyRequisition(); }
	static response(form_id:number): Response { return Empties.getEmptyResponse(form_id); }
	static question(): Question { return Empties.getEmptyQuestion(); }
	static answer(): Answer { return Empties.getEmptyAnswer(); }
	static form(): Form { return Empties.getEmptyForm(); }
	static item_points(): Item_Points { return Empties.getEmptyItemPoints(); }
	static response_info(form_id:number): ResponseInfo { return Empties.getEmptyResponseInfo(form_id); }
	static currency(): Currency { return Empties.getEmptyCurrency(); }
	static client(): UserBalance { return Empties.getEmptyClient(); }
	static address(): Address { return Empties.getEmptyAddress(); }
	static user(): UserBalance { return Empties.getEmptyUser(); }
	static user_attachment(): User_Attachment { return Empties.getEmptyUserAttachment(); }
	static category(): Category { return Empties.getEmptyCategory(); }
	static bank_movement(): Bank_Movement { return Empties.getEmptyBankMovement(); }
	static billing_data(): Billing_Data { return Empties.getEmptyBillingData(); }
	static order_item(item:Item): Order_Item { return Empties.getEmptyOrderItem(item); }
	static orderItemInfo(item:Item,category:Category | null = null,price:Price | null = null, exceptions:Item_Exception[] = [],prices:Price[] = []) { return Empties.getOrderItemInfo(item, category, price, exceptions, prices); }
	static item_info(): ItemInfo { return Empties.getEmptyItemInfo(); }
	static orderInfo(rest:RestService, price_type_list:Price_Type[] = [], store_list:Store[] = []): OrderInfo { return Empties.getOrderInfo(rest, price_type_list, store_list); }
	static store(): Store { return Empties.getEmptyStore(); }
	static stock_take_item(): Stocktake_Item { return Empties.getEmptyStocktakeItem(); }
	static stocktake(): Stocktake { return Empties.getEmptyStocktake(); }
	static stocktake_item_info(): StocktakeItemInfo { return Empties.getEmptyStocktakeItemInfo(); }
	static stocktake_info(): StocktakeInfo { return Empties.getEmptyStocktakeInfo(); }
	static quote(rest:RestService): Quote { return Empties.getEmptyQuote(rest); }
	static quoteInfo(rest:RestService): QuoteInfo { return Empties.getQuoteInfo(rest); }
	static user_permission(): User_Permission { return Empties.getEmptyUserPermission(); }
	static item(): Item { return Empties.getEmptyItem(); }
	static offer(): Offer { return Empties.getEmptyOffer(); }
	static post(): Post { return Empties.getEmptyPost(); }
	static price_type(): Price_Type { return Empties.getEmptyPriceType(); }
	static serial_info(): SerialInfo { return Empties.getEmptySerialInfo(); }
	static serial(): any { return Empties.getEmptySerial(); }
	static emptyFacturaMetaData(): FacturaMetaData { return Empties.getEmptyFacturaMetaData(); }
	static preferences(): Preferences { return Empties.getEmptyPreferences(); }
	static shipping_item_batch(): Shipping_Item_Batch { return Empties.getEmptyShippingItemBatch(); }
	static printer(): Printer { return Empties.getEmptyPrinter(); }
	static ticket(): Ticket { return Empties.getEmptyTicket(); }
}
